import React from 'react';
import { steps } from '../data/mockData';

const HowItWorks = () => {
  return (
    <section className="how-it-works-section">
      <div className="section-header">
        <div className="section-line gold" />
        <h2 className="section-title">¿CÓMO FUNCIONA?</h2>
        <div className="section-line gold" />
      </div>
      <p className="section-subtitle">
        Un proceso sencillo de 4 pasos
      </p>
      <div className="steps-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="step-item">
              <div className="step-number-circle">
                <span>{step.id}</span>
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className="step-connector" />
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
